import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { asTitle } from "utils/Utils";
import { Event } from "utils/history/Event";

import { Role } from "core/blueprint/trajectory/TrajectoryBlueprintService";

import EvaluationRoleRow from "core/trajectory/access/EvaluationRoleRow";
import RoleInsertRow from "core/trajectory/access/RoleInsertRow";

export interface EvaluationRoleTableProps {
	roles: Role[];
	editable: boolean;

	isValid: (name: string) => boolean;
	onInsert: (role: Role) => void;
	onChange: (event: Event) => void;
	onDelete: (index: number) => void;
}

function EvaluationRoleTable(props: EvaluationRoleTableProps): JSX.Element {
	const { t } = useTranslation();

	return (
		<>
			<Box sx={{ minHeight: 32 }} />
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>{asTitle(t("role"))}</TableCell>
						<TableCell
							padding="checkbox"
							sx={{ minWidth: 100 }}
							align="center"
							id="edit-header">
							{asTitle(t("edit"))}
						</TableCell>
						<TableCell
							padding="checkbox"
							sx={{ minWidth: 100 }}
							align="center"
							id="read-header">
							{asTitle(t("read"))}
						</TableCell>
						<TableCell sx={{ width: 60 }} padding="none" />
					</TableRow>
				</TableHead>
				<TableBody>
					{props.roles.map((role, index) => (
						<EvaluationRoleRow
							key={role.name}
							index={index}
							role={role}
							editable={props.editable}
							onChange={props.onChange}
							onDelete={props.onDelete}
						/>
					))}
					{props.editable && (
						<RoleInsertRow
							colSpan={2}
							isValid={props.isValid}
							onInsert={props.onInsert}
						/>
					)}
				</TableBody>
			</Table>
		</>
	);
}

export default EvaluationRoleTable;
